import { render, staticRenderFns } from "./TraxAccountBasicClientCrudForm.vue?vue&type=template&id=0c2a34b0"
import script from "./TraxAccountBasicClientCrudForm.vue?vue&type=script&lang=js"
export * from "./TraxAccountBasicClientCrudForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports